'use strict';
journalEntryListController.$inject = [
	'$scope',
	'$q',
	'$interval',
	'reportHelper',
	'authService',
	'utilsService',
	'unitService',
	'accountStructureService',
	'prPayGroupService',
	'USER_CLAIMS',
	'BUSY_MESSAGE',
];
angular.module('schoolLinqApp').controller('journalEntryListController', journalEntryListController);

function journalEntryListController(
	$scope,
	$q,
	$interval,
	reportHelper,
	authService,
	utilsService,
	unitService,
	accountStructureService,
	prPayGroupService,
	USER_CLAIMS,
	BUSY_MESSAGE
) {
	var viewModel = getViewModel();
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.loadingPromise = $q.all([
		$scope.vm.loadJournalCodes($scope.vm),
		$scope.vm.loadFiscalYears($scope.vm),
		$scope.vm.loadAccountStructures($scope.vm),
		$scope.vm.loadPayGroups($scope.vm),
	]);

	function getViewModel() {
		var model = {
			message: BUSY_MESSAGE.Loading,
			report: {
				fromDT: null,
				toDT: null,
				thirteenthMonth: false,
				fiscalYear: null,
				journalCode: null,
				accountFiltersGrid: null,
				accountFiltersType: null,
				voidsOnly: false,
				payGroupId: 0,
				payGroupSort: false,
			},
			journalCodes: [],
			fiscalYears: [],
			prPayGroups: [],
			unifiedElementMap: null,
			unifiedAccountMask: null,
			datesDisabled: false,

			isPayrollAccessible: false,
			validationErrors: [],
			errors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (model.report.thirteenthMonth === true) {
				if (!model.report.fiscalYear) {
					model.validationErrors.push('Please select a valid Fiscal Year.');
					isValid = false;
				}
			} else {
				if (!model.report.fromDT) {
					model.validationErrors.push("Please select a 'From' date.");
					isValid = false;
				}

				if (!model.report.toDT) {
					model.validationErrors.push("Please select a 'To' date.");
					isValid = false;
				}
			}

			if (isValid === true && model.report.fromDT > model.report.toDT) {
				model.validationErrors.push('From Date cannot be after the To Date.');
				isValid = false;
			}

			if (model.report.journalCode === null) {
				model.validationErrors.push('Please select a Journal Code.');
				isValid = false;
			}

			var idx = 0;
			var acctF = null;
			if (model.unifiedElementMap) {
				for (idx = 0; idx < model.report.accountFiltersGrid.length; idx++) {
					acctF = model.report.accountFiltersGrid[idx];

					if (!acctF.fromValue) {
						model.validationErrors.push("Element: '" + acctF.element + "' must have a From value!");
						isValid = false;
					} else {
						if (!acctF.toValue) {
							acctF.toValue = acctF.fromValue;
						}

						if (parseInt(acctF.fromValue) > parseInt(acctF.toValue)) {
							model.validationErrors.push("Element: '" + acctF.element + "' has an invalid range!");
							isValid = false;
						}
					}
				}
			} else {
				for (idx = 0; idx < model.report.accountFiltersType.length; idx++) {
					acctF = model.report.accountFiltersType[idx];

					for (var qidx = 0; qidx < acctF.queries.length; qidx++) {
						var query = acctF.queries[qidx];

						if (!query.QueryOption) {
							model.validationErrors.push('Please select a range item for Account Range!');
							isValid = false;
						}
						if (!query.Value) {
							model.validationErrors.push('Please enter a value for Account Range!');
							isValid = false;
						}
						if (isValid === false) {
							break;
						}
					}
				}
			}

			return isValid;
		}

		function openReport(model) {
			if (!validateReportParams(model)) return false;

			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			let elementRangeParams = [];

			if (model.unifiedElementMap) {
				angular.forEach(model.report.accountFiltersGrid, function (acctF) {
					if (acctF.fromValue && acctF.fromValue.length > 0) {
						elementRangeParams.push(acctF);
					}
				});
			} else {
				angular.forEach(model.report.accountFiltersType, function (acctF) {
					angular.forEach(acctF.queries, function (query) {
						if (query.QueryOption && query.Value) {
							var paramModel = {
								element: '',
								maxLength: 0,
								maxValue: 0,
								fromValue: 0,
								toValue: 0,
								accountTypeId: 0,
								startIndex: 0,
								queryOption: '',
							};

							paramModel.queryOption = query.QueryOption;
							paramModel.fromValue = parseInt(query.Value);
							paramModel.toValue = parseInt(-1);
							elementRangeParams.push(paramModel);
						}
					});
				});
			}

			var report = {
				FromDT: model.report.fromDT,
				ToDT: model.report.toDT,
				ThirteenthMonth: model.report.thirteenthMonth,
				FiscalYear: model.report.fiscalYear,
				JournalCode: model.report.journalCode.Code,
				VoidsOnly: model.report.voidsOnly,
				ElementRangeModelCol: elementRangeParams,
				PayGroupId: model.report.payGroupId,
				PayGroupSort: model.report.payGroupSort,
				ExcludeThirteenth: false,
				RefNo: '',
				ExcludeNullTransactionGUIDs: false,
			};

			reportHelper.getReport($scope, '/api/fundreports/journalentrylistreport', report, 'JournalEntryListReport.pdf');
		}

		function exportExcel(model) {
			if (!validateReportParams(model)) return false;

			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingExcelFile;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			let elementRangeParams = [];

			if (model.unifiedElementMap) {
				angular.forEach(model.report.accountFiltersGrid, function (acctF) {
					if (acctF.fromValue && acctF.fromValue.length > 0) {
						elementRangeParams.push(acctF);
					}
				});
			} else {
				angular.forEach(model.report.accountFiltersType, function (acctF) {
					angular.forEach(acctF.queries, function (query) {
						if (query.QueryOption && query.Value) {
							var paramModel = {
								element: '',
								maxLength: 0,
								maxValue: 0,
								fromValue: 0,
								toValue: 0,
								accountTypeId: 0,
								startIndex: 0,
								queryOption: '',
							};

							paramModel.queryOption = query.QueryOption;
							paramModel.fromValue = parseInt(query.Value);
							paramModel.toValue = parseInt(-1);
							elementRangeParams.push(paramModel);
						}
					});
				});
			}

			var report = {
				FromDT: model.report.fromDT,
				ToDT: model.report.toDT,
				ThirteenthMonth: model.report.thirteenthMonth,
				FiscalYear: model.report.fiscalYear,
				JournalCode: model.report.journalCode.Code,
				VoidsOnly: model.report.voidsOnly,
				ElementRangeModelCol: elementRangeParams,
				PayGroupId: model.report.payGroupId,
				PayGroupSort: model.report.payGroupSort,
			};

			reportHelper.getExcel($scope, '/api/fundreports/journalentrylistexcel', report, 'JournalEntryList.xlsx');
		}

		function loadJournalCodes(model) {
			return utilsService.getjournalCodes().then(_.partial(finishLoadingJournalCodes, model));

			function finishLoadingJournalCodes(model, response) {
				model.journalCodes = response.data.codes;
				if (!model.isPayrollAccessible) {
					model.journalCodes = _.reject(model.journalCodes, { Code: 'PR' });
				}
				//model.journalCodes = _.filter(response.data.codes, function (code) {
				//    return code.Code === 'AJ' || code.Code === 'BJ';
				//});
			}
		}

		function loadFiscalYears(model) {
			$scope.loadingPromise = unitService.getFiscalYears().then(_.partial(finishLoadingYears, model));

			function finishLoadingYears(model, response) {
				model.fiscalYears = response.data.fiscalYears;
				return angular.noop;
			}
		}

		function loadAccountStructures(model) {
			return accountStructureService.getStructure().then(_.partial(finishLoadingAccountStructures, model));

			function finishLoadingAccountStructures(model, response) {
				model.unifiedElementMap = response.data.accountStructure.UnifiedElementMap;
				model.unifiedAccountMask = response.data.accountStructure.UnifiedAccountMask;
				return angular.noop;
			}
		}

		function loadPayGroups(model) {
			if (model.isPayrollAccessible) {
				return prPayGroupService.getPRPayGroups(true).then(_.partial(finishedLoadingPayGroups, model));

				function finishedLoadingPayGroups(model, response) {
					model.prPayGroups = response.data.prPayGroups;
					model.prPayGroups.unshift({ Id: 0, Description: 'All' });
					model.report.payGroupId = 0;
					return angular.noop;
				}
			}
		}

		function fiscalYearSelected(model) {
			let lastYear = model.report.fiscalYear - 1;
			let fromDate = lastYear + '0701';
			let toDate = model.report.fiscalYear + '0630';
			model.report.fromDT = moment(fromDate, 'YYYYMMDD').toDate();
			model.report.toDT = moment(toDate, 'YYYYMMDD').toDate();
			model.datesDisabled = true;
		}

		return angular.extend(model, {
			loadJournalCodes: _.partial(loadJournalCodes, model),
			loadFiscalYears: _.partial(loadFiscalYears, model),
			loadAccountStructures: _.partial(loadAccountStructures, model),
			loadPayGroups: _.partial(loadPayGroups, model),
			fiscalYearSelected: _.partial(fiscalYearSelected, model),
			openReport: _.partial(openReport, model),
			exportExcel: _.partial(exportExcel, model),
		});
	}
}
